require 'angular'

app = angular.module('workflow.app')

app.controller('ProjectManualController', require './ProjectManualController')

require('./DuplicateRequestModal')
